/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateAutoSalesInvoiceResultDto
 */
export interface GenerateAutoSalesInvoiceResultDto {
    /**
     * 
     * @type {string}
     * @memberof GenerateAutoSalesInvoiceResultDto
     */
    outcome: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateAutoSalesInvoiceResultDto
     */
    invoiceId?: string;
}

/**
 * Check if a given object implements the GenerateAutoSalesInvoiceResultDto interface.
 */
export function instanceOfGenerateAutoSalesInvoiceResultDto(value: object): value is GenerateAutoSalesInvoiceResultDto {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    return true;
}

export function GenerateAutoSalesInvoiceResultDtoFromJSON(json: any): GenerateAutoSalesInvoiceResultDto {
    return GenerateAutoSalesInvoiceResultDtoFromJSONTyped(json, false);
}

export function GenerateAutoSalesInvoiceResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateAutoSalesInvoiceResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function GenerateAutoSalesInvoiceResultDtoToJSON(value?: GenerateAutoSalesInvoiceResultDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'outcome': value['outcome'],
        'invoiceId': value['invoiceId'],
    };
}

